import { Map as MapboxMap } from "mapbox-gl";

// The map's colours: land and water as faded paper-map inks, in keeping with
// the game's parchment, navy and brick red.
export const LAND = "#F4EBD8";
export const WATER = "#A8C5CC";
const PARK = "#CBD4A8";

// What covers the land, by the terrain data's own classes.
export const LANDCOVER_COLOUR = [
  "match",
  ["get", "class"],
  "wood",
  "#BFCD9F",
  "scrub",
  "#D5D8AE",
  "grass",
  "#DFE0B8",
  "crop",
  "#E9E4C0",
  "snow",
  "#FCFAF3",
  LAND,
] as unknown as string;

// Recolours the base style's own layers.
export const paintMapColours = (map: MapboxMap) => {
  map.setPaintProperty("land", "background-color", LAND);
  map.setPaintProperty("water", "fill-color", WATER);
  map.setPaintProperty("waterway", "line-color", WATER);
  map.setPaintProperty("landuse", "fill-color", [
    "match",
    ["get", "class"],
    ["park", "wood", "scrub", "grass", "pitch", "cemetery"],
    PARK,
    ["sand"],
    "#EFE0BE",
    ["glacier"],
    "#FCFAF3",
    "#EBE0C8",
  ]);
};
